export const ONBOARDING_TASKS = [
    {
        slug: 'content-inspiration'
    },
    {
        slug: 'create-group'
    },
    {
        slug: 'schedule-report'
    },
    {
        slug: 'schedule-post'
    }
] as const;
